module.exports = {
	name: 'number',
	validation(yup) {
		return yup.number().max(2147483647);
	}
};
